module.exports = __webpack_public_path__ + "static/img/zx-wxzx-img.44ccc1d1.png";